"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _radio = require("../../../../radio");
var _misc = require("../../../../misc");
var _Icon = _interopRequireDefault(require("../../../../icon/Icon"));
var _helpers = _interopRequireDefault(require("./helpers"));
var _helpers2 = require("../helpers");
var _FormulaValueHeader = _interopRequireDefault(require("./FormulaValueHeader.style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var FormulaValueHeader = function FormulaValueHeader(_ref) {
  var rule = _ref.rule,
    disabled = _ref.disabled,
    labels = _ref.labels,
    ruleIndex = _ref.ruleIndex,
    ruleChange = _ref.ruleChange,
    actions = _ref.actions,
    setHasChanges = _ref.setHasChanges;
  return /*#__PURE__*/_react["default"].createElement(_FormulaValueHeader["default"], {
    "data-testid": "formula-value-header"
  }, /*#__PURE__*/_react["default"].createElement(_misc.MenuList, {
    position: "top-right",
    disabled: disabled,
    menuItems: (0, _helpers2.menuListItems)({
      labels: labels,
      actions: actions,
      ruleIndex: ruleIndex,
      setHasChanges: setHasChanges
    }),
    ignoreSingleItemLogic: true
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-android-more-vertical"
  })), /*#__PURE__*/_react["default"].createElement(_radio.RadioGroup, {
    className: "share-view-radiogroup",
    disabled: disabled,
    selectedValue: R.path(['complex', 'activeType'], rule),
    options: (0, _helpers2.shareViewOptions)(labels),
    onChange: function onChange(event) {
      return ruleChange('complex', (0, _helpers["default"])(event, rule));
    }
  }));
};
FormulaValueHeader.defaultProps = {
  disabled: false
};
FormulaValueHeader.propTypes = {
  disabled: _propTypes["default"].bool,
  rule: _propTypes["default"].shape({}).isRequired,
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  ruleIndex: _propTypes["default"].number.isRequired,
  ruleChange: _propTypes["default"].func.isRequired,
  actions: _propTypes["default"].shape({
    deleteRuleBlock: _propTypes["default"].func.isRequired
  }).isRequired,
  setHasChanges: _propTypes["default"].func.isRequired
};
FormulaValueHeader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FormulaValueHeader",
  "props": {
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "rule": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    },
    "labels": {
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": true
    },
    "ruleIndex": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "ruleChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "actions": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "deleteRuleBlock": {
            "name": "func",
            "required": true
          }
        }
      },
      "required": true
    },
    "setHasChanges": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};
var _default = FormulaValueHeader;
exports["default"] = _default;